import { EasyModeProvider } from '../../contexts/EasyModeContext';
import EasyModeTour from '../tour/EasyModeTour';
import EasyModeContent from './EasyModeContent';

// the tour sits inside the provider because it drives the wizard it is describing
const EasyMode = () => (
  <EasyModeProvider>
    <EasyModeContent />
    <EasyModeTour />
  </EasyModeProvider>
);

export default EasyMode;
